import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Box, Modal } from '~/components/blocks';
import { usePractitionerRole } from '~/hooks/use-practitioner-role';
import { messageModalState } from '~/state/partials/message_modal/atoms';

import { InitialPanel } from './InitialPanel';
import { InputPanel } from './InputPanel';
import { ReadOnlyPanel } from './ReadOnlyPanel';

export const MessageModal = React.memo(() => {
  const { verifyRole } = usePractitionerRole();
  const isVerified = verifyRole('pharmacist');

  const { isOpen, currentPanel } = useAtomValue(messageModalState);
  const resetMessageModalState = useResetAtom(messageModalState);

  const handleClose = useCallback(() => resetMessageModalState(), [resetMessageModalState]);
  return (
    <Modal open={isOpen} size="m" onClose={handleClose}>
      <Modal.Body>
        <Box height="625px">
          {isVerified && currentPanel === 'input' && <InputPanel />}
          {isVerified && currentPanel === 'initial' && <InitialPanel />}
          {!isVerified && <ReadOnlyPanel />}
        </Box>
      </Modal.Body>
    </Modal>
  );
});

MessageModal.displayName = 'MessageModal';
